/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FacilityRegion } from './FacilityRegion';
import {
    FacilityRegionFromJSON,
    FacilityRegionFromJSONTyped,
    FacilityRegionToJSON,
} from './FacilityRegion';

/**
 * 
 * @export
 * @interface CreateFacilityRegion201Response
 */
export interface CreateFacilityRegion201Response {
    /**
     * 
     * @type {FacilityRegion}
     * @memberof CreateFacilityRegion201Response
     */
    data?: FacilityRegion;
}

/**
 * Check if a given object implements the CreateFacilityRegion201Response interface.
 */
export function instanceOfCreateFacilityRegion201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateFacilityRegion201ResponseFromJSON(json: any): CreateFacilityRegion201Response {
    return CreateFacilityRegion201ResponseFromJSONTyped(json, false);
}

export function CreateFacilityRegion201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateFacilityRegion201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : FacilityRegionFromJSON(json['data']),
    };
}

export function CreateFacilityRegion201ResponseToJSON(value?: CreateFacilityRegion201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': FacilityRegionToJSON(value.data),
    };
}

